<div class="CompLawCase">
  <mat-accordion>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Case information
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- FLAG -->
      <a *ngIf="documentType === 'COMPETITION_LAW_DOC' || documentType === 'STATE_AID'" class="Flag" [routerLink]="'/site/case-database/' + documentType" [queryParams]="{ countries: countryCode }">
        <img class="Flag-img" src="/api/flags/flag/{{countryCode}}">
      </a>
      <span *ngIf="documentType === 'DMA_CASE'" class="Flag">
        <img class="Flag-img" src="/api/flags/flag/{{countryCode}}">
      </span>
      <!-- THEMES -->
      <div class="Tags Tags--themes" *ngIf="keywords?.length > 0 || target">
        <h4 class="Tags-title">Theme:</h4>
        <!-- ANTITRUST -->
        <ul class="Tags-list" *ngIf="keywords?.length > 0 && documentType === 'COMPETITION_LAW_DOC'">
          <li *ngFor="let tag of keywords;">
            <a [routerLink]="'/site/case-database/' + documentType" [queryParams]="{ themes: tag }">
              {{ ('uishared.competitionLawThemes.' + tag) | transloco }}
            </a>
          </li>
        </ul>
        <!-- STATEAID -->
        <span *ngIf="target" [innerHtml]="displayTags(target.answer, target.name)"></span>
        <!-- DMA -->
        <ul class="Tags-list" *ngIf="keywords?.length > 0 && documentType === 'DMA_CASE'">
          <li *ngFor="let tag of keywords;">
            <a [routerLink]="'/site/case-database/' + documentType" [queryParams]="{ themes: tag }">
              {{ ('uishared.dmaThemes.' + tag) | transloco }}
            </a>
          </li>
        </ul>
      </div>
      <!-- SUBTHEMES -->
      <div class="Tags Tags--subthemes" *ngIf="infringements || dmaSubthemes || target && aim">
        <h4 class="Tags-title">Subtheme(s):</h4>
        <!-- ANTITRUST -->
        <span *ngIf="infringements" [innerHtml]="displayTags(infringements.answer, infringements.name)"></span>
        <!-- STATEAID -->
        <span *ngIf="target && aim" [innerHtml]="displayStateAidSubthemeTags(target.answer, aim.answer)"></span>
        <!-- DMA -->
        <span *ngIf="dmaSubthemes" [innerHtml]="displayTags(dmaSubthemes.answer, dmaSubthemes.name)"></span>
      </div>
      <!-- DMA CORE PLATFORM -->
      <div class="Tags Tags--subthemes" style="margin-bottom: -5px;" *ngIf="dmaCps">
        <h4 class="Tags-title">Core platform service(s):</h4>
        <span *ngIf="dmaCps" [innerHtml]="displayTags(dmaCps.answer, dmaCps.name)"></span>
      </div>
      <!-- SECTIONS WITH EMPHASIS STATE AID & COMP LAW-->
      <div class="Section-container" *ngIf="documentType === 'COMPETITION_LAW_DOC' || documentType === 'STATE_AID'">
        <div class="Bloc" *ngFor="let section of emphasisSections" [ngClass]="section.alignment" [class.Bloc--hide]="hideSections(section.name)">
          <h2 class="DocumentSection-title">
            {{('uishared.competitionLawTitles.' + section.name) | transloco}}
          </h2>
          <div class="DocumentSection-answer" [innerHtml]="section.answer | linkifyImage"></div>
        </div>
        <div class="Bloc right" *ngIf="documentType === 'STATE_AID' && hasAmountSectionValues()">
          <h2 class="DocumentSection-title">Amount</h2>
          <div class="DocumentSection-answer">
            <ul class="List List-amount">
              <li>Max. aid intensity (general rule): <span [innerHtml]="displayData(getSectionByName('section.sa_aid_intensity'))"></span></li>
              <li>Total aid budget: <span [innerHtml]="displayData(getSectionByName('section.sa_total_amount'))"></span></li>
              <li>Duration: <span [innerHtml]="displayData(getSectionByName('section.sa_duration'))"></span> months</li>
              <li>Average aid budget per year: <span [innerHtml]="displayData(getSectionByName('section.sa_amount_per_year'))"></span></li>
              <li>Aid budget per capita: <span [innerHtml]="displayData(getSectionByName('section.sa_eligible_costs'))"></span></li>
            </ul>
          </div>
        </div>
      </div>
      <!-- SECTIONS DMA-->
      <div class="Section-container" *ngIf="documentType === 'DMA_CASE'">
        <div class="Bloc" *ngFor="let section of dmaEmphasisSections" [ngClass]="section.alignment">
          <h2 class="DocumentSection-title" *ngIf="isDmaCompanySection(section.typeName)">
            {{ ('uishared.dmaCaseTitles.' + section.name) | transloco }}
          </h2>
          <h2 class="DocumentSection-title" *ngIf="!isDmaCompanySection(section.typeName)">
            Company
          </h2>          
          <div class="DocumentSection-answer" [innerHtml]="section.answer | linkifyImage"></div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
